import { BrowserRouter, Routes, Route } from 'react-router-dom'

import NavBar from './components/NavBar/NavBar'
import Carousel from './components/Carousel/Carousel'
import ProjectsListContainer from './components/ProjectListContainer/ProjectListContainer'
import ProjectDetailContainer from './components/ProjectDetailContainer/ProjectDetailContainer'
import Contact from './components/Contact/Contact'
import About from './components/About/About'
import Error from './components/Error/Error'

import './App.css'

function App() {
  return (
    <div className='app'>
      <BrowserRouter>
        <header>
          <NavBar />
        </header>
        <main className='appMain'>
          <Routes>
            <Route path='/' element={ <Carousel />} />
            <Route path='/projects' element={ <ProjectsListContainer />} />
            <Route path='/category/:categoryId' element={ <ProjectsListContainer /> }/>
            <Route path='/project/:projectId' element={ <ProjectDetailContainer /> }/>
            <Route path='/about' element={ <About />} />
            <Route path='/contact' element={ <Contact />} />
            <Route path='*' element={ <Error />} />
          </Routes>
        </main>
        
      </BrowserRouter>
    </div>
  )
}

export default App